import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '@/shared/components/ui/empty'
import { Spinner } from '@/shared/components/ui/spinner'

export const LoadingContent = () => {
	const { t } = useTranslation()

	return (
		<Empty>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<Spinner className='text-muted-foreground' />
				</EmptyMedia>
				<EmptyTitle>
					{t('bulk_modal_bulk_update_loading', {
						defaultValue: 'Preparing data...',
					})}
				</EmptyTitle>
				<EmptyDescription>
					{t('bulk_modal_bulk_update_loading_description', {
						defaultValue:
							'We are preparing the data for the update. Please wait a moment.',
					})}
				</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
